import LayoutPage from "../../Components/LayoutPage";
import { ChallengeContainer } from "./Components/ChallengeContainer";

export default function ChallengePage() {
  return (
    <LayoutPage activeIndex={2} navItems={["خرید چالش جدید"]} childrenClassName="flex-1 min-h-0 flex flex-col gap-5 overflow-y-auto">
      <ChallengeContainer />
    </LayoutPage>
  )
}